(() => {
  const ROOT_SELECTOR = '[data-shefa-mobile-menu-v2]';

  const setPanelState = (root, control, open) => {
    const panelId = control.getAttribute('aria-controls');
    if (!panelId) return;

    const panel = root.querySelector(`[data-shefa-drawer-panel="${panelId}"]`);
    if (!panel) return;

    control.setAttribute('aria-expanded', String(open));
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', String(!open));

    if (open) {
      panel.removeAttribute('inert');
    } else {
      panel.setAttribute('inert', '');

      panel.querySelectorAll('[data-shefa-drawer-toggle][aria-expanded="true"]').forEach((childControl) => {
        setPanelState(root, childControl, false);
      });
    }
  };

  const resetDrawer = (root) => {
    root.querySelectorAll('[data-shefa-drawer-toggle]').forEach((control) => {
      setPanelState(root, control, false);
    });
  };

  const toggleControl = (root, control) => {
    const open = control.getAttribute('aria-expanded') !== 'true';
    setPanelState(root, control, open);
  };

  const initDrawer = (root) => {
    if (!root || root.dataset.shefaMobileMenuReady === 'true') return;
    root.dataset.shefaMobileMenuReady = 'true';

    root.addEventListener('click', (event) => {
      const control = event.target.closest('[data-shefa-drawer-toggle]');
      if (!control || !root.contains(control)) return;

      event.preventDefault();
      event.stopPropagation();
      toggleControl(root, control);
    });

    root.addEventListener('keydown', (event) => {
      const control = event.target.closest('[data-shefa-drawer-toggle]');
      if (!control || !root.contains(control)) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      event.stopPropagation();
      toggleControl(root, control);
    });

    const drawerDetails = root.closest('#Details-menu-drawer-container');
    if (drawerDetails) {
      drawerDetails.addEventListener('toggle', () => {
        // Every time the hamburger drawer opens, start with Categorias collapsed.
        resetDrawer(root);
      });
    }

    resetDrawer(root);
  };

  const initAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initDrawer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
